import { Navigate, Outlet } from 'react-router-dom';
import { usePlatformAuthStore } from '../store/platformAuthStore';

export function RequirePlatformAuth() {
  const token = usePlatformAuthStore((s) => s.accessToken);
  if (!token) return <Navigate to="/platform/login" replace />;
  return <Outlet />;
}
